// src/redux/reducers/cityReducer.js
import {
    FETCH_GETINSTITUTE_FAILURE,
    FETCH_GETINSTITUTE_REQUEST,
    FETCH_GETINSTITUTE_SUCCESS, 
    SET_SELECTED_GETINSTITUTE 
  } from '../types';
  
  const initialState = {
    loading: false,
    getinstituteList: [],
    selectedinstituteId: null, 
    error: null,
  };
  
  const getInstitutesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETINSTITUTE_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETINSTITUTE_SUCCESS:
        return { ...state, loading: false, getinstituteList: action.payload };
      case FETCH_GETINSTITUTE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETINSTITUTE:
        return { ...state, selectedinstituteId: action.payload };
      default:
        return state;
    }
  };
  
  export default getInstitutesReducer;



  